import { API_URL } from "./Config";
import { formatDate, formatDateForFiltering } from "./DateUtils";
import { IDetailsResponse } from "./IDetailsResponse";
import { PageResult, PageRequest } from "./Pagination";

//https://data-int.epa.ie/leap/api/v1/SiteVisit/byid?sv_id=804D4B88-ED4E-E811-A2DD-0050568A2D1A

/*
"sitevisitid": "804d4b88-ed4e-e811-a2dd-0050568a2d1a",
    "type": "Site Visit",
    "subject": "Air Visit - Sampling Infrastructure",
    "reference": "SV15542",
    "status": "Closed",
    "licence_id": "24c8e87d-7c61-e211-9eb5-0050568a69e2",
    "licenceprofile_id": null,
    "licenseesubmission_id": "4e8aadee-e69b-e811-a308-0050568a2d1a",
    "visit_date": "2018-04-11T00:00:00",
    "report_issued_date": "2018-07-25T00:00:00",
    "compliance": "Yes",
    "summary": null,
    "instigated_by": "Enforcement Plan Visit",
    "sampletaken": "No",
    "odourassessment": null,
    "adourassessmentcompliant": "n/a",
    "licence_regno": "P0815-02",
    "profile_number": "P0815"
*/

//Site Visit Details
export interface ISiteVisitDetails extends IDetailsResponse {
  sitevisitid: string;
  type: string;
  subject: string;
  reference: string;
  status: string;
  licence_id: string;
  licenceprofile_id: string;
  licenseesubmission_id: string;
  visit_date: string;
  report_issued_date: string;
  compliance: string;
  summary: string;
  instigated_by: string;
  announced: string;
  visittype: string;
  sampletaken: string;
  odourassessment: string;
  adourassessmentcompliant: string;
  licence_regno: string;
  profile_number: string;
}

//Site Visit Row
export interface ISiteVisit {
  sitevisitid: string;
  type: string;
  subject: string;
  reference: string;
  status: string;
  licence_id: string;
  licenceprofile_id: string;
  licenseesubmission_id: string;
  visit_date: string;
  visit_type: string;
  licence_regno: string;
  profile_number: string;
}

export async function GetSiteVisitDetailsAsync(
  siteVisitId: string
): Promise<ISiteVisitDetails> {
  var url = `${API_URL}/SiteVisit/byid?sv_id=${siteVisitId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/sitevisit-details`;
  }

  var response = await fetch(url);
  var body = <ISiteVisitDetails>await response.json();

  return <ISiteVisitDetails>{
    response: response,
    sitevisitid: body.sitevisitid,
    type: body.type,
    subject: body.subject,
    reference: body.reference,
    status: body.status,
    licence_id: body.licence_id,
    licenceprofile_id: body.licenceprofile_id,
    licenseesubmission_id: body.licenseesubmission_id,
    visit_date: formatDate(body.visit_date),
    report_issued_date: formatDate(body.report_issued_date),
    compliance: body.compliance,
    summary: body.summary,
    announced: body.announced,
    visittype: body.visittype,
    instigated_by: body.instigated_by,
    sampletaken: body.sampletaken,
    odourassessment: body.odourassessment,
    adourassessmentcompliant: body.adourassessmentcompliant,
    licence_regno: body.licence_regno,
    profile_number: body.profile_number,
  };
}

export const GetSiteVisitsFromLicenseeReturnFetchUrl = (
  licenseeReturnId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  let params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }
  let url = `${API_URL}/SiteVisit/listbylrid?lr_id=${licenseeReturnId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/sitevisit-licenseereturns`;
  }

  return url;
};

export const GetSiteVisitsFromComplianceInvestigationFetchUrl = (
  complianceInvestigationId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  let params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }
  let url = `${API_URL}/SiteVisit/listbyciid?ci_id=${complianceInvestigationId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/sitevisits-ci`;
  }

  return url;
};

export const GetSiteVisitsFromNonComplianceFetchUrl = (
  nonComplianceId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  let params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }
  let url = `${API_URL}/SiteVisit/listbyncid?nc_id=${nonComplianceId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/sitevisit-noncompliance`;
  }

  return url;
};
